// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* container */
.modal-content {
  width: 400px;
  background: #fff;
  border-radius: 8px;
  padding: 20px;
}

/* chips */
.selected-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 12px;
}
.chip {
  display: flex;
  align-items: center;
  background: #e5f1fb;
  border-radius: 16px;
  padding: 4px 8px;
}
.chip-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 6px;
  object-fit: cover;
}
.chip-name {
  margin-right: 6px;
  font-size: 14px;
}
.chip-remove {
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  color: #555;
}

/* inputs */
.group-name-input,
.msg-search {
  width: 95%;
  padding: 8px;
  margin-bottom: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

/* suggestions */
.suggestions-list {
  max-height: 180px;
  overflow-y: auto;
  border: 1px solid #ddd;
  background: #fff;
  border-radius: 4px;
  margin-bottom: 12px;
}
.suggestion-item {
  display: flex;
  align-items: center;
  padding: 6px 10px;
  cursor: pointer;
}
.suggestion-item.selected {
  background: #0078d4;
  color: white;
}
.suggestion-item:hover {
  background: #f0f0f0;
}
.chat-avatar-small {
  width: 28px;
  height: 28px;
  margin-right: 8px;
  border-radius: 50%;
  object-fit: cover;
}
.no-results {
  padding: 8px;
  color: #888;
  text-align: center;
}

/* buttons */
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.create-btn {
  padding: 6px 12px;
  background: #0078d4;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.create-btn:disabled {
  background: #aaa;
  cursor: not-allowed;
}
.cancel-btn {
  padding: 6px 12px;
  background: #ddd;
  color: #333;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/Chat/GroupModal.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA,UAAU;AACV;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA,WAAW;AACX;;EAEE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":["/* container */\n.modal-content {\n  width: 400px;\n  background: #fff;\n  border-radius: 8px;\n  padding: 20px;\n}\n\n/* chips */\n.selected-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-bottom: 12px;\n}\n.chip {\n  display: flex;\n  align-items: center;\n  background: #e5f1fb;\n  border-radius: 16px;\n  padding: 4px 8px;\n}\n.chip-avatar {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  margin-right: 6px;\n  object-fit: cover;\n}\n.chip-name {\n  margin-right: 6px;\n  font-size: 14px;\n}\n.chip-remove {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  font-size: 16px;\n  line-height: 1;\n  color: #555;\n}\n\n/* inputs */\n.group-name-input,\n.msg-search {\n  width: 95%;\n  padding: 8px;\n  margin-bottom: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n/* suggestions */\n.suggestions-list {\n  max-height: 180px;\n  overflow-y: auto;\n  border: 1px solid #ddd;\n  background: #fff;\n  border-radius: 4px;\n  margin-bottom: 12px;\n}\n.suggestion-item {\n  display: flex;\n  align-items: center;\n  padding: 6px 10px;\n  cursor: pointer;\n}\n.suggestion-item.selected {\n  background: #0078d4;\n  color: white;\n}\n.suggestion-item:hover {\n  background: #f0f0f0;\n}\n.chat-avatar-small {\n  width: 28px;\n  height: 28px;\n  margin-right: 8px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n.no-results {\n  padding: 8px;\n  color: #888;\n  text-align: center;\n}\n\n/* buttons */\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n.create-btn {\n  padding: 6px 12px;\n  background: #0078d4;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n.create-btn:disabled {\n  background: #aaa;\n  cursor: not-allowed;\n}\n.cancel-btn {\n  padding: 6px 12px;\n  background: #ddd;\n  color: #333;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
